import React from 'react';

const ShowArchivedBox = (props) => (
  <div className="showArchivedBox">
    <label>Display Archived</label>
    <input type="checkbox"
           value="archived"
           checked={props.displayArchived}
           onChange={props.handleCheck}
           className="checkbox-archived"
    />
  </div>
);

export default ShowArchivedBox;
